export default "__VITE_ASSET__Boq1_Pkw__"